export default {
  props: {
    type: {
      default: "card"
    }
  },
  data() {
    return {
      templates: [],
      component: null
    };
  },
  mounted() {
    if (this.type && this.templates[this.type]) {
      this.component = this.templates[this.type];
    }
  }
};
